import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';

export function MarkKeyboard(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;

    return (
        <kbd
            className="rounded border px-1 font-mono shadow-[0_1px_0_0_var(--sp-color-border-base)]"
            {...attributes}
        >
            {children}
        </kbd>
    );
}
